<template>
  <vx-card>
    <div>
      <form-wizard
        color="rgba(var(--vs-warning), 1)"
        errorColor="rgba(var(--vs-warning), 1)"
        :title="null"
        :subtitle="null"
        :finishButtonText="$t('admin.devices.new.form.SubmitBtn')"
        :nextButtonText="$t('admin.devices.new.form.NextBtn')"
        :backButtonText="$t('admin.devices.new.form.BackBtn')"
      >
        <tab-content
          :title="$t('admin.devices.new.steps.step1')"
          class="mb-5"
          :before-change="validateStep1"
        >
          <form data-vv-scope="step-1">
            <vs-divider class="customer-divider mt-0 mb-8" />
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full mb-base">
                <label class="vs-input--label" for="email"
                  >{{ $t("login.FormMail") }}:</label
                >
                <vs-input
                  v-validate="'required|email'"
                  name="email"
                  type="email"
                  v-model="email"
                  color="warning"
                  class="w-full"
                  :placeholder="$t('login.FormMail')"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('step-1.email')"
                >
                  <span v-if="email == ''">
                    {{ $t("login.FormMailEmpty") }}
                  </span>
                  <span v-else>
                    {{ $t("login.FormMailValid") }}
                  </span>
                </span>
              </div>
              <div class="vx-col md:w-1/2 w-full mb-base">
                <label class="vs-input--label" for="rent_period"
                  >{{ $t("admin.devices.new.form.RentPeriod") }}:</label
                >
                <vs-input
                  v-validate="'required|numeric'"
                  name="rent_period"
                  type="text"
                  v-model="rent_period"
                  class="w-full"
                  color="warning"
                  :placeholder="
                    $t('admin.devices.new.form.RentPeriodPlaceholder')
                  "
                />

                <span
                  class="text-danger text-sm"
                  v-show="errors.has('step-1.rent_period')"
                >
                  <span v-if="rent_period == ''">
                    {{ $t("form.ErrorMessages.Required") }}
                  </span>
                  <span v-else>
                    {{ $t("form.ErrorMessages.Numeric") }}
                  </span>
                </span>
              </div>
            </div>
            <vs-divider class="customer-divider mt-0 mb-8" />
          </form>
        </tab-content>
        <tab-content
          :title="$t('admin.devices.new.steps.step2')"
          class="mb-5"
          :before-change="validateStep2"
        >
          <form data-vv-scope="step-2">
            <div class="text-right w-full">
              <vs-button
                class="mb-base sx:w-full"
                color="#737373"
                type="filled"
                @click="autoFillBtn"
                >{{ $t("admin.devices.new.form.AutoFillBtn") }}</vs-button
              >
              <vs-prompt
                blur
                @close="autoFillModalClose"
                :active.sync="autoFillModal"
                color="#626262"
                :title="$t('admin.devices.new.form.AutoFillBtn')"
                :buttons-hidden="true"
              >
                <div class="con-exemple-prompt">
                  <form>
                    <div class="mt-6">
                      <label class="vs-input--label" for="auto_fill_count"
                        >{{ $t("admin.devices.new.form.DeviceCount") }}:</label
                      >
                      <vs-input
                        v-validate="'required|numeric'"
                        name="auto_fill_count"
                        type="text"
                        v-model="auto_fill_count"
                        class="w-full"
                        color="warning"
                      />
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has('auto_fill_count')"
                      >
                        <span v-if="auto_fill_count == ''">
                          {{ $t("form.ErrorMessages.Required") }}
                        </span>
                        <span v-else>
                          {{ $t("form.ErrorMessages.Numeric") }}
                        </span>
                      </span>
                    </div>
                    <vs-divider class="customer-divider my-8" />
                    <div class="text-right">
                      <vs-button
                        type="filled"
                        color="light"
                        class="mr-3 mb-2 text-dark"
                        @click="autoFillModalClose"
                        >{{ $t("profile.Close") }}</vs-button
                      >
                      <vs-button
                        type="filled"
                        color="warning"
                        class="mb-2"
                        @click.prevent="autoFillModalSubmitForm"
                        >{{ $t("admin.devices.new.form.AutoFillBtn")
                        }}<feather-icon
                          class="ml-3 bx-spin"
                          :class="
                            isAutoFillSubmitFormLoading == true ? '' : 'd-none'
                          "
                          icon="LoaderIcon"
                          svgClasses="w-5 h-5"
                        ></feather-icon
                      ></vs-button>
                    </div>
                  </form>
                </div>
              </vs-prompt>
            </div>
            <vs-divider class="customer-divider mt-0 mb-8" />
            <vs-alert
              active="true"
              color="danger"
              class="mb-8 text-center"
              v-if="items.length == 0"
            >
              <span>
                {{ $t("admin.devices.new.form.NoDeviceError") }}
              </span>
            </vs-alert>
            <div
              class="vx-row flex items-end"
              v-for="(item, index) in items"
              :key="item.id"
            >
              <div class="vx-col sm:w-2/3 w-full mb-base">
                <label class="vs-input--label" :for="`device_${index}`"
                  >{{ $t("admin.devices.new.form.Device") }}:</label
                >
                <v-select
                  v-validate="'required'"
                  :name="`device_${index}`"
                  :options="deviceOptions"
                  :clearable="true"
                  :placeholder="$t('admin.devices.new.form.SelectDevice')"
                  v-model="item.value"
                  @input="handleDeviceChange(item.value, index)"
                  @search="handleDeviceSearch"
                  @search:blur="deviceOptions = []"
                  @search:focus="
                    deviceEmptyDataText = $t(
                      'admin.devices.new.form.SearchDevice'
                    )
                  "
                >
                  <template #no-options>
                    <div>
                      {{ deviceEmptyDataText }}
                    </div>
                  </template>
                </v-select>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has(`step-2.device_${index}`)"
                >
                  {{ $t("form.ErrorMessages.Required") }}
                </span>
                <span
                  class="text-danger text-sm"
                  v-show="item.duplicate_errror == true"
                >
                  {{ $t("admin.devices.new.form.DuplicateDeviceError") }}
                </span>
              </div>
              <div class="vx-col sm:w-1/3 w-full mb-base text-right">
                <vs-button
                  type="border"
                  color="danger"
                  @click="removeItem(index)"
                  class="sx:w-full"
                  >{{ $t("admin.devices.new.form.DeleteBtn") }}</vs-button
                >
              </div>
              <vs-divider
                class="customer-divider mt-0 mb-8"
                :class="index + 1 == items.length ? 'd-none' : ''"
              />
            </div>
            <vs-button
              color="#737373"
              type="filled"
              icon-pack="feather"
              icon="icon-plus"
              @click="repeateAgain"
              class="sx:w-full"
              >{{ $t("admin.devices.new.form.AddDeviceBtn") }}</vs-button
            >
            <vs-divider class="customer-divider mt-8 mb-8" />
          </form>
        </tab-content>
        <template slot="finish">
          <vs-button type="filled" color="warning"
            >{{ $t("admin.devices.new.form.SubmitBtn")
            }}<feather-icon
              class="ml-3 bx-spin"
              :class="isSubmitFormLoading == true ? '' : 'd-none'"
              icon="LoaderIcon"
              svgClasses="w-5 h-5"
            ></feather-icon
          ></vs-button>
        </template>
      </form-wizard>
    </div>
  </vx-card>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import i18n from '../../../../../i18n/i18n.js'
import vSelect from 'vue-select'

export default {
  data () {
    return {
      email: '',
      rent_period: '',
      autoFillModal: false,
      auto_fill_count: '',
      isAutoFillSubmitFormLoading: false,
      items: [
        {
          id: 1,
          value: '',
          duplicate_errror: false
        }
      ],
      nextTodoId: 2,
      deviceOptions: [],
      deviceEmptyDataText: i18n.t('admin.devices.new.form.SearchDevice'),
      isSubmitFormLoading: false
    }
  },
  methods: {
    autoFillBtn () {
      this.autoFillModal = true
      this.auto_fill_count = ''
    },

    autoFillModalClose () {
      this.autoFillModal = false
      this.auto_fill_count = ''
    },

    repeateAgain () {
      this.items.push({
        id: (this.nextTodoId += this.nextTodoId),
        value: '',
        duplicate_errror: false
      })
    },

    removeItem (index) {
      this.items.splice(index, 1)
    },

    handleDeviceChange (val, index) {
      this.items[index].duplicate_errror = false
    },

    handleDeviceSearch (search) {
      const searchData = `?search=${  search}`
      if (search.length > 2) {
        this.deviceSearchData(searchData)
      } else if (search.length === 0) {
        this.deviceEmptyDataText = i18n.t(
          'admin.devices.new.form.SearchDevice'
        )
        this.deviceOptions = []
      }
    },

    deviceSearchData (search) {
      this.deviceOptions = []
      this.deviceEmptyDataText = i18n.t('table.LoadingText')
      this.$store
        .dispatch('getSearchRentalDevice', search)
        .then((response) => {
          this.deviceOptions = []
          if (response.data.length) {
            response.data.map((value) => {
              this.deviceOptions.push({
                value: value.id,
                label: value.device_serial
              })
            })
          } else {
            this.deviceOptions = []
            this.deviceEmptyDataText = i18n.t(
              'admin.devices.new.form.NoResultDevice'
            )
          }
        })
        .catch((error) => {
          this.errorMsg(error)
        })
    },

    autoFillModalSubmitForm () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.isAutoFillSubmitFormLoading = true
          const count = this.auto_fill_count
            ? `?count=${  this.auto_fill_count}`
            : ''
          this.$store
            .dispatch('getAutoFillDevice', count)
            .then((response) => {
              this.items = []
              if (response.data.length) {
                response.data.map((value) => {
                  this.items.push({
                    id: (this.nextTodoId += this.nextTodoId),
                    value: {
                      value: value.id,
                      label: value.device_serial
                    },
                    duplicate_errror: false
                  })
                })
              } else {
                this.$vs.notify({
                  title: i18n.t('notifyAlert.warning.title'),
                  text: i18n.t('admin.devices.new.form.WarningMessage'),
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  color: 'warning',
                  position: 'top-right',
                  time: 4000
                })
              }
              this.isAutoFillSubmitFormLoading = false
              this.autoFillModal = false
            })
            .catch((error) => {
              this.isAutoFillSubmitFormLoading = false
              this.errorMsg(error)
            })
        }
      })
    },

    validateStep1 () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-1').then((result) => {
          if (result) {
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },

    validateStep2 () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('step-2').then((result) => {
          const dataObj = {}
          let duplicateControl = true
          this.items.map((val, index) => {
            if (val.value) {
              if (index >= 1) {
                if (dataObj[val.value.value]) {
                  this.items[index].duplicate_errror = true
                  duplicateControl = false
                } else {
                  dataObj[val.value.value] = val
                  this.items[index].duplicate_errror = false
                }
              } else {
                dataObj[val.value.value] = val
              }
            }
          })

          if (result && this.items.length > 0 && duplicateControl === true) {
            const data = {
              rent_total_period: parseInt(this.rent_period),
              rent_linked_email: this.email,
              devices: []
            }
            this.items.map((val) => {
              data.devices.push(val.value.value)
            })
            this.isSubmitFormLoading = true
            this.$store
              .dispatch('createRentalDevice', data)
              .then(() => {
                this.isSubmitFormLoading = false
                this.$vs.notify({
                  title: i18n.t('notifyAlert.success.title'),
                  text: i18n.t('admin.devices.new.form.SuccessMessage'),
                  iconPack: 'feather',
                  icon: 'icon-check',
                  color: 'success',
                  position: 'top-right',
                  time: 5000
                })
                this.$router.push('/admin/devices').catch(() => {})
              })
              .catch((error) => {
                this.isSubmitFormLoading = false
                this.errorMsg(error)
              })
            resolve(true)
          } else {
            reject('correct all values')
          }
        })
      })
    },
    errorMsg (error) {
      this.$store.dispatch('errorMsg', error).then((res) => {
        this.$vs.notify({
          title: i18n.t('notifyAlert.error.title'),
          text: res,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger',
          position: 'top-right'
        })
      })
    }
  },
  components: {
    FormWizard,
    TabContent,
    vSelect
  }
}
</script>
<style lang="scss" scoped>
@media (max-width: 575px) {
  .sx\:w-full {
    width: 100% !important;
  }
}
</style>

<style lang="scss">
.vue-form-wizard .navbar .navbar-nav>li>a.wizard-btn, .vue-form-wizard .wizard-btn {
    font-weight: 400 !important;
    min-width: 100px !important;
    font-family: "Montserrat", Helvetica, Arial, sans-serif;
    font-size: 1rem !important;
    
}
</style>